const getIconAsSvgString = (width, height, color, textColor) => `<svg width="${width}" height="${height}" viewBox="0 0 36 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#shadow)">
        <circle cx="18" cy="16" r="13" fill="${color}" stroke="${textColor}" stroke-width="2"/>
        </g>
        <defs>
        <filter id="shadow" x="0" y="0" width="36" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="2"/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23086_30000"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
        <feBlend mode="normal" in2="effect1_dropShadow_23086_30000" result="effect2_dropShadow_23086_30000"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_23086_30000" result="shape"/>
        </filter>
        </defs>
      </svg>
`;
export {
  getIconAsSvgString
};
//# sourceMappingURL=icon.js.map
